import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Cookies from 'js-cookie';

interface loginUserResponse {
    user: object;
    access_token: string;
    refresh_token: string;
}

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api/v1/auth/',
        credentials: 'include',
        prepareHeaders(headers) {
            const csrfToken = Cookies.get('csrftoken');
            if (csrfToken) {
                headers.set('X-CSRFToken', csrfToken);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        login: builder.mutation<loginUserResponse, string>({
            query: (creds) => ({
                url: '/login/',
                method: 'POST',
                body: creds,
            }),
        }),
        logout: builder.mutation({
            query: () => ({
                url: '/logout/',
                method: 'POST',
            }),
        }),
        passwordReset: builder.mutation({
            query: (payload) => ({
                url: '/password/reset/',
                method: 'POST',
                body: payload,
            }),
        }),
        passwordResetConfirm: builder.mutation({
            query: (payload) => ({
                url: '/password/reset/confirm/',
                method: 'POST',
                body: payload,
            }),
        }),
        userProfile: builder.query({
            query: () => '/user/',
        }),
    }),
});

export const {
    useLoginMutation,
    useUserProfileQuery,
    useLogoutMutation,
    usePasswordResetMutation,
    usePasswordResetConfirmMutation,
} = authApi;
export default authApi;
